import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Colours from '@shared/ui/atoms/Colours';
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import { SimpleSpinner } from '@shared/ui/atoms/SimpleSpinner';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { Cell, SavingOverlay } from './WhereaboutsV2Styles';

interface Props {
  label: string;
  bg: string;
  borderColour: string;
  saving?: boolean;
  style?: CSSProperties;
  onClick?: () => void;
  firstName?: string;
  lastName?: string;
}

export function EmptyDayCell({ label, bg, borderColour, saving, style, onClick, firstName, lastName }: Props) {
  const { t } = useTranslation();
  return (
    <EmptyCell $bg={bg} $borderColour={borderColour} $saving={saving} style={style} onClick={onClick}>
      <DefaultContent>
        {(firstName || lastName) && (
          <UserAvatarAndName firstName={firstName ?? ''} lastName={lastName ?? ''} hideName={true} colour="darkBlue" disableHover={true} />
        )}
        <BodySmall weight={600}>{label}</BodySmall>
      </DefaultContent>
      <HoverContent>
        <PlusIcon src="/assets/icons/font/Add.svg" alt="" />
        <BodySmall weight={600} colour={Colours.darkGrey}>{t('whereabouts-v2.set-whereabouts')}</BodySmall>
      </HoverContent>
      {saving && <SavingOverlay><SimpleSpinner size={20} /></SavingOverlay>}
    </EmptyCell>
  );
}

const DefaultContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  transition: opacity 0.15s;
`;

const HoverContent = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s;
`;

const EmptyCell = styled(Cell)<{ $saving?: boolean }>`
  cursor: ${props => props.$saving ? 'default' : 'pointer'};
  position: relative;
  transition: border-style 0.15s, border-color 0.15s;
  &:hover {
    border-style: dashed;
    border-color: ${Colours.darkGrey};
  }
  &:hover ${DefaultContent} {
    opacity: 0;
  }
  &:hover ${HoverContent} {
    opacity: 1;
  }
`;

const PlusIcon = styled.img`
  width: 16px;
  height: 16px;
`;

